module.exports = __webpack_public_path__ + "@/assets/img/10.620fe682.jpg";